// extracted by mini-css-extract-plugin
module.exports = {"filtersWrapper":"styles_filtersWrapper__37jIW","filtersWrapperTablet":"styles_filtersWrapperTablet__3W7TH"};